/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';
import { ForecastDemandSaleRate } from './forecastDemandSaleRate';

export class ForecastDemand extends DaoModel {
  constructor(guid, day, sale_rates) {
    super(guid);
    this.day = day || '1990-1-1';
    this.sale_rates = sale_rates || [];
  }

  serialize() {
    return {
      // Following api format
      day: this.day,
      sale_rates: this.sale_rates.map((rate) => rate.serialize())
    };
  }

  static toInstance(props = {}) {
    const sale_rates = ForecastDemandSaleRate.toInstanceList(props.sale_rates.sort((a, b) => a.guid.localeCompare(b.guid))) || [];
    return new ForecastDemand(props.day, props.day, sale_rates);
  }

  hasMatchingServices(serviceGuid) {
    return this.sale_rates.some((saleRate) => saleRate.hasMatchingServices(serviceGuid));
  }

  isDayEditable() {
    return new Date(this.day) > new Date();
  }
}
